import React, { useMemo } from "react";
import RadioBlocksExtended from "../RadioBlocksExtended/RadioBlocksExtended";
import { WALL_FINISH_VARIANTS } from "src/helpers/wallFinishes";

interface ColorSelectProps {
  label?: string;
  value?: string;
  onChange: (value: string) => void;
  innerColor?: boolean;
  disabled?: boolean;
  className?: string;
}

const ColorSelect: React.FC<ColorSelectProps> = ({
  label,
  value,
  onChange,
  innerColor = false,
  disabled = false,
  className,
}) => {
  const variants = useMemo(() => {
    if (!innerColor) return WALL_FINISH_VARIANTS;
    // Inner side: allow "empty" plus potdeksel and vuren variants
    return WALL_FINISH_VARIANTS.filter(
      (variant) =>
        variant.profileId === "potdeksel" || variant.profileId === "vuren"
    );
  }, [innerColor]);

  const blocks = useMemo(() => {
    const baseBlocks = variants.map((variant, index) => ({
      id: index + 1,
      name: variant.label,
      value: variant.value,
      imageUrl: variant.imageUrl,
      color: "transparent",
      price: 0,
      description: "",
    }));

    if (!innerColor) return baseBlocks;

    return [
      {
        id: 0,
        name: "Geen Element",
        value: "empty",
        imageUrl: `${process.env.PUBLIC_URL}/images/empty.svg`,
        color: "",
        price: 0,
        description: "",
      },
      ...baseBlocks,
    ];
  }, [innerColor, variants]);

  const disableValues = disabled ? blocks.map((b) => b.value) : [];

  return (
    <div className={`color-select ${className ?? ""}`}>
      {label && <div className="color-select-label">{label}</div>}
      <RadioBlocksExtended
        blocks={blocks}
        value={value || "empty"}
        onChange={onChange}
        disableValues={disableValues}
        className="storage-color-radio-blocks"
        stopPropagation={true}
      />
    </div>
  );
};

export default ColorSelect;
